export enum MASS_ADD_ERROR {
	NOT_FOUND = 'NOT_FOUND',
	DUPLICATE = 'DUPLICATE',
	PRICED_OPTIONS = 'PRICED_OPTIONS'
}

export enum FULFILLMENT_OPTION_ID {
	WHITE_GLOVE = 804
}
